import { z } from "zod";

export const AuthSchema = z.object({
    token: z.string(),
    username: z.string().optional(),
    password: z.string().optional()
});

export type Auth = z.infer<typeof AuthSchema>;

export const AuthPartialSchema = AuthSchema.partial();
export type AuthPartial = z.infer<typeof AuthPartialSchema>;

export function parseAuth(data: any, partial = false) {
    if (!partial) {
        return {
            ...AuthSchema.parse(data)
        };
    }
    else if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }
    else if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }
    else if (Object.keys(data).length === 0) {
        throw new Error('Payload Object can\'t be null');
    }
    else {
        return {
            ...AuthSchema.parse(data)
        };
    }
}
